import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import WPDropdown from "../../packages/WPDropdown";
import WPInput from "../../packages/WPInput/WPInput";
import { CHEMICAL_FIELDS_CONFIG, CHEMICAL_FIELDS_KEYS } from "./config";

import "./index.scss";
import { ensureChemicalLibraryHydrated } from "../chemicalLibrary/ChemicalLibraryDialog/ChemicalLibraryDialog.api";
import { getChemicalOptionsByCategory } from "./utils";

const ChemicalSelectionFields = ({
  sectionKeys = CHEMICAL_FIELDS_KEYS,
  selectedChemicals = {},
  onChemicalChange,
  currencyUnit,
  mass,
  disabled = false,
  containerClassName = "",
  showPriceField = true,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { plantChemicalLibrary } = useSelector((state) => state);

  const chemicalOptionsByCategory = useMemo(
    () => getChemicalOptionsByCategory(plantChemicalLibrary),
    [plantChemicalLibrary],
  );

  useEffect(() => {
    if (!plantChemicalLibrary || plantChemicalLibrary.length === 0) {
      const fetchData = async () => {
        await ensureChemicalLibraryHydrated(dispatch, t);
      };

      fetchData();
    }
  }, []);

  return (
    <div className={`chemical-selection-fields ${containerClassName}`}>
      {sectionKeys.map((categoryKey) => {
        const sectionMeta = CHEMICAL_FIELDS_CONFIG[categoryKey] || {};
        const dropdownLabel = t(sectionMeta.chemicalLabelKey || "");
        const chemicalValue = Number(
          selectedChemicals?.[categoryKey]?.chem_id ??
            sectionMeta.defaultOption,
        );
        const options = chemicalOptionsByCategory?.[categoryKey] || [];

        const priceValue = selectedChemicals?.[categoryKey]?.price || "";

        return (
          <div
            key={categoryKey}
            className={`chemical-selection-row${showPriceField ? "" : " chemical-selection-row-no-price"}`}
          >
            <WPDropdown
              id={`chemical_dropdown_${categoryKey}`}
              label={dropdownLabel}
              value={chemicalValue}
              options={options}
              onChange={
                disabled
                  ? undefined
                  : (option) => onChemicalChange?.(categoryKey, option)
              }
              placeholder={dropdownLabel}
              required
              disabled={disabled}
            />
            {showPriceField && (
              <WPInput
                id={`chemical_price_${categoryKey}`}
                label={t("defaultInformationStrings.price")}
                type="number"
                value={priceValue}
                onChange={
                  disabled
                    ? undefined
                    : (event) =>
                        onChemicalChange?.(categoryKey, {
                          value: event.target.value,
                        })
                }
                suffix={`${currencyUnit}/${mass}`}
                required
                requiredMsg={t("ValueStrings.requiredField")}
                disabled={disabled}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ChemicalSelectionFields;
